import React, { useState } from "react"
import SmallestHeadingComponent from "./SmallestHeadingComponent"

export interface AccordionProps {
    title: string
    children: React.ReactNode
    risk?: boolean,
    initial?: boolean
}

function Accordion(props: AccordionProps) {
    const iconUp = (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="size-4">
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m4.5 15.75 7.5-7.5 7.5 7.5"
            />
        </svg>
    )

    const iconDown = (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="size-4">
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m19.5 8.25-7.5 7.5-7.5-7.5"
            />
        </svg>
    )

    const [open, setOpen] = useState<boolean>(props.initial !== undefined ? props.initial : false)

    function toggle() {
        setOpen(!open)
    }

    function isRisk() {
        return props.risk !== undefined && props.risk
    }

    return (
        <div className={"rounded shadow flex flex-col " + (isRisk() ? "border-rose-800 bg-rose-100" : "bg-white")}>
            <div
                onClick={toggle}
                className={"flex p-3 items-center cursor-pointer"}>
                {
                    !isRisk() ? (
                        <SmallestHeadingComponent>
                            {props.title}
                        </SmallestHeadingComponent>
                    ) : (
                        <div
                            className={
                                "font-bold text-rose-800"
                            }>
                            {props.title}
                        </div>
                    )
                }
                <div className={"ml-auto"}>{open ? iconUp : iconDown}</div>
            </div>
            {open ? (
                <div className={"p-3 border-t"}>{props.children}</div>
            ) : (
                <></>
            )}
        </div>
    )
}

export default Accordion
